import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'VT',
  name: 'V.T.',
  role: 'ESL Teacher | New York, USA',
  text: 'The A2 volume completely changed how my students experience progress. The lessons are already structured — I just deliver them. My classes feel more professional than ever.'
}, {
  initials: 'CR',
  name: 'C.R.',
  role: 'ESL Instructor | Melbourne, Australia',
  text: 'The emergency lessons saved me more times than I can count in my first month. I used to panic when my plan fell apart. Now I just open the backup library and teach.'
}, {
  initials: 'DG',
  name: 'D.G.',
  role: 'ESL Teacher | Toronto, Canada',
  text: 'I review the grammar guide before every session and walk in knowing exactly what I am going to explain. The teacher explanations are written in a way I can actually use.'
}, {
  initials: 'AM',
  name: 'A.M.',
  role: 'ESL Instructor | London, United Kingdom',
  text: 'The mixed-level guide gave me back my confidence with multi-level groups. Now I have the right adaptation ready before the class even starts.'
}, {
  initials: 'SR',
  name: 'S.R.',
  role: 'ESL Teacher | Dublin, Ireland',
  text: 'The speaking activity bank was a complete revelation. My students talk about those sessions for days. They feel like real communication — not just exercises.'
}];
export function ExtendedTestimonials() {
  return <section className="bg-charcoal px-4 py-16 sm:py-24" data-id="element-13">
      <div className="mx-auto max-w-6xl" data-id="element-14">
        <div className="mx-auto max-w-3xl text-center" data-id="element-15">
          <p className="text-xs font-bold tracking-[.18em] text-gold-300" data-id="element-16">
            PROOF FROM THE CLASSROOM
          </p>
          <h2 className="mt-4 font-display text-3xl font-bold leading-tight text-white sm:text-5xl" data-id="element-17">
            What ESL teachers who already have their system are saying:
          </h2>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-18">
          {testimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className={`relative flex flex-col rounded-2xl border border-line bg-black p-7 ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-19">
              <QuoteIcon size={44} className="absolute right-6 top-6 text-gold-700/35" aria-hidden="true" data-id="element-20" />
              <div className="mb-5 flex gap-1 text-gold-300" data-id="element-21">
                {Array.from({
              length: 5
            }).map((_, starIndex) => <StarIcon key={starIndex} size={15} fill="currentColor" data-id="element-22" />)}
              </div>
              <p className="relative z-10 flex-1 text-sm leading-6 text-stone-300 italic" data-id="element-23">
                “{testimonial.text}”
              </p>
              <div className="mt-7 flex items-center gap-3" data-id="element-24">
                <span className="grid h-11 w-11 place-items-center rounded-full bg-gold-300 text-sm font-bold text-black" data-id="element-25">
                  {testimonial.initials}
                </span>
                <div data-id="element-26">
                  <p className="text-sm font-bold text-white" data-id="element-27">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-gold-100" data-id="element-28">{testimonial.role}</p>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}